import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import React from 'react';

function CreditCardIcon(props: SvgIconProps) {
  return (
    <SvgIcon width="22" height="20" viewBox="0 0 22 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <defs>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="4f4nujk4fa">
          <stop stopColor="#3E8BFF" offset="0%" />
          <stop stopColor="#3E8BFF" offset="100%" />
        </linearGradient>
      </defs>
      <path
        d="M17.548.036a2.373 2.373 0 0 1 2.745 1.922l1.67 9.471c.11.624-.03 1.253-.392 1.771a2.354 2.354 0 0 1-1.53.975l-1.083.19v3.192a2.372 2.372 0 0 1-2.37 2.37H2.37A2.372 2.372 0 0 1 0 17.556V8.176c0-.971.588-1.807 1.426-2.173l-.123-.696a2.372 2.372 0 0 1 1.922-2.745zm.117 12.927H1.293v4.594c0 .593.483 1.077 1.077 1.077h14.218c.594 0 1.077-.484 1.077-1.078v-4.593zM6.22 16.038a.646.646 0 0 1 0 1.293H3.288a.646.646 0 0 1 0-1.293zM17.96 1.293c-.062 0-.124.005-.187.016L3.45 3.835a1.07 1.07 0 0 0-.696.443 1.07 1.07 0 0 0-.178.805l.127.723h13.885a2.372 2.372 0 0 1 2.37 2.37v4.877l.859-.151c.283-.05.53-.208.695-.443a1.07 1.07 0 0 0 .178-.805l-1.67-9.471a1.079 1.079 0 0 0-1.06-.89zm-.295 8.738H1.293v1.64h16.372v-1.64zm-1.077-2.932H2.37c-.594 0-1.077.483-1.077 1.077v.562h16.372v-.562c0-.594-.483-1.077-1.077-1.077z"
        fill="url(#4f4nujk4fa)"
        fillRule="nonzero"
        opacity="1"
      />
    </SvgIcon>
  );
}

export default CreditCardIcon;
